export default __webpack_public_path__ + "static/media/bonanza.22d10352.svg";